import React from 'react';
import { Spinner } from '../spinner/Spinner';
import { useLoading } from '../../../contexts/LoadingContext';

/**
 * Shows spinner component when triggered by useLoading context. Useful when need to show loading for large datasets and you don't want to block parts of the UI.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI 
 */
export const LoadingSpinner = () => {
    const {showingSpinner, spinnerMessage} = useLoading();

    if(!showingSpinner) return null;

    return (
        <>
            <div className='fixed top-[10%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white p-5 rounded-md border border-black' role="status">
                <Spinner className="text-center"/>
                <h1 className='text-center font-Poppins-Med mt-3 italic text-tcbGreen'>{spinnerMessage}</h1>
            </div>
        </>
    )
}